module.exports = __webpack_public_path__ + "static/media/eur.193ede75.svg";